const isFewLeft = ({ quantity, unlimited }) => !unlimited && (quantity > 0 && quantity < 10);

export default isFewLeft;
